import { useAgents } from '@mint-lib/ai-chat';
import { Button } from '@mint-lib/tw-components';
import { AvatarAi } from '@mint-lib/tw-components/ai';

type AgentsButtonProps = {
  ref?: React.RefObject<HTMLButtonElement>;
  setIsAgentsOpen?: (isOpen: boolean) => void;
};

export const AgentsButton = ({
  setIsAgentsOpen,
  ref,
  ...props
}: AgentsButtonProps) => {
  const { agentListWidgetData } = useAgents();
  return (
    <Button
      variant={'plain'}
      className="mr-6.5 flex cursor-pointer flex-row gap-0"
      onClick={() => setIsAgentsOpen?.(true)}
      ref={ref}
      {...props}
    >
      {agentListWidgetData.map((card, index) => (
        <div
          key={card.agentName}
          className="-mr-3"
          style={{ zIndex: index + 1 }}
        >
          <AvatarAi role={card.role} size={'small'} hasPointer />
        </div>
      ))}
    </Button>
  );
};
